module.exports = __webpack_public_path__ + "static/media/AvertaStd-Bold.4d0a35d9.woff";